import React from "react";
import {
  Card,
  CardBody,
  CardImg,
  CardText,
  CardTitle,
  Button,
} from "reactstrap";
import img3 from "../../../../assets/images/boats/03.png";
import { Link } from "react-router-dom"; // Import Link for navigation

const WishlistCard = ({ item, onRemove }) => {
  console.log("item", item);
  return (
    <Card
      style={{ border: "0px", boxShadow: "none" }}
      className="wishlist-card"
    >
      <div className="wishlist-img">
        <img
          width="100%"
          src={item.details.data.Vessel_Thumb}
          alt="Fish Image"
        />
        <div className="wishlist-info">
          <Link
            to={`/stockdetails/${item.details.data._id}`}
            className="name"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {<div className="name">{item.details.data.Product_Name}</div>}
          </Link>

          <div className="name">
            {item.details.data.Total_Available_Quantity}kg
          </div>
          <div className="price">{item.details.data.Price_per_Kg}/kg</div>
        </div>
        <div className="remove-btn2" onClick={() => onRemove(item._id)}>
          &#x2715;
        </div>
      </div>
    </Card>
  );
};

export default WishlistCard;
